import { datadogRum } from "@datadog/browser-rum"
import { useEffect } from "react"
import { reactPlugin } from "@datadog/browser-rum-react"
import {
  API_URI,
  APP_URL,
  DATADOG_APPLICATION_ID,
  DATADOG_APPLICATION_NAME,
  DATADOG_CLIENT_TOKEN,
  DATADOG_ENV,
  DATADOG_SITE,
} from "../env_variables"

export const DataDogRum = () => {
  useEffect(() => {
    if (["staging", "prod"].includes(DATADOG_ENV)) {
      if (datadogRum.getInitConfiguration()) {
        return
      }

      datadogRum.init({
        applicationId: DATADOG_APPLICATION_ID ?? "Louis",
        clientToken: DATADOG_CLIENT_TOKEN ?? "Louis",
        site: DATADOG_SITE as "datadoghq.com",
        service: DATADOG_APPLICATION_NAME,
        env: DATADOG_ENV,
        allowedTracingUrls: [API_URI, APP_URL],
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
        enablePrivacyForActionName: true,
        defaultPrivacyLevel: "mask-user-input",
        plugins: [reactPlugin({ router: true })],
      })
    }
  }, [])

  return <></>
}
